import { TBaseComponentProps } from '@segway/core'

import { Float } from '@/components'
import { Footer } from '@/components/footer'
import { Header } from '@/components/header'

/**
 * 默认 Layout
 */
const MainLayout = (props: TBaseComponentProps) => {
  return (
    <>
      <Header />
      {props.children}
      <Float />
      <Footer />
    </>
  )
}

export default MainLayout
